/* eslint-disable custom-rules/modal-and-drawer-requires-title */
import { useForm } from '@uhg-abyss/web/hooks/useForm';
import { useMediaQuery } from '@uhg-abyss/web/hooks/useMediaQuery';
import { Drawer } from '@uhg-abyss/web/ui/Drawer';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { FormProvider } from '@uhg-abyss/web/ui/FormProvider';
import { Heading } from '@uhg-abyss/web/ui/Heading';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ProviderLocation, ProviderType } from '../../models/ProviderDetails';
import { phoneOnly } from '../ConstantsStyles';
import { CorrectInformation } from './CorrectInformation';
import { SuggestEditFooter } from './SuggestEditFooter';
import { SuggestEditProviderCard } from './SuggestEditProviderCard';
import { ConfirmSuggestions } from '.';

type Props = {
  suggestEditDrawer: boolean;
  setSuggestEditDrawer: Function;
  providerLocations: ProviderLocation[];
  providerType: ProviderType;
  providerName: string;
  inNetwork: string;
  avatar: string | undefined;
};

export const SuggestEditDrawerCard = ({
  suggestEditDrawer,
  setSuggestEditDrawer,
  providerLocations,
  providerType,
  providerName,
  inNetwork,
  avatar,
}: Props) => {
  const { t } = useTranslation();
  const mobileScreen = useMediaQuery(phoneOnly);
  const [page, setPage] = useState(0);
  const [isChecked, setChecked] = useState(false);

  const [selectedLocationValue, setSelectedLocationValue] = useState(
    providerLocations[0]
  );

  const form = useForm();

  const componentsList = [
    <CorrectInformation
      inNetwork={inNetwork}
      key="correct-information"
      providerName={providerName}
      providerType={providerType}
      selectedLocationValue={selectedLocationValue}
    />,
    <ConfirmSuggestions
      key="confirm-suggestions"
      providerType={providerType}
    />,
  ];

  const handleDrawerClose = () => {
    setSuggestEditDrawer(false);
    setPage(0);
    setChecked(false);
  };

  return (
    <FormProvider
      data-auto-testid="suggest-edit-form"
      data-testid="suggest-edit-form"
      state={form}
    >
      <Drawer
        css={{
          'abyss-modal-close-button': {
            marginTop: '$md',
            marginRight: '$sm',
            top: '8px',
          },
        }}
        header={
          <Heading
            color="$neutralGray7"
            css={{
              'abyss-heading-root': {
                width: '177px',
              },
            }}
            level={4}
            size="sm"
          >
            {t('SUGGEST_EDIT.HEADING')}
          </Heading>
        }
        isOpen={suggestEditDrawer}
        onClose={handleDrawerClose}
        position="right"
        size={mobileScreen ? window.innerHeight - 104 : 408}
      >
        <div>
          <Flex
            alignContent="flex-start"
            css={{
              'abyss-flex-root': {
                padding: 0,
                width: '100%',
              },
            }}
            direction="column"
          >
            <SuggestEditProviderCard
              avatar={avatar}
              providerLocations={providerLocations}
              providerName={providerName}
              providerType={providerType}
              updateLocation={setSelectedLocationValue}
            />
            <Heading
              css={{
                'abyss-heading-root': {
                  marginTop: '24px',
                },
              }}
              level={6}
              size="xs"
            >
              {page === 0
                ? t('SUGGEST_EDIT.INCORRECT_ITEMS')
                : t('SUGGEST_EDIT.CONFIRM_SUGGESTIONS')}
            </Heading>
            {componentsList[page]}
          </Flex>
        </div>
        <SuggestEditFooter
          isChecked={isChecked}
          page={page}
          providerType={providerType}
          setChecked={setChecked}
          setPage={setPage}
        />
      </Drawer>
    </FormProvider>
  );
};
